import { JwtStorage, CurrentUserService, ErrorLogger, NavManager } from '../gs-core/client';
import { AuthFetch, createAuthFetch, PrmService } from '../gs-core/common';

import { DocService } from './DocService';
import { TitleService } from './TitleService';
import { OwningUnitService } from './OwningUnitService';
import { CommonConfig } from '../common/config';
import { SubjectService } from './SubjectService';
import { CommonDocLoader } from './CommonDocLoader';
import { DocUploadService } from './DocUploadService';
import { JobService } from './JobService';

export class ServiceRegistry {
  docService: DocService;
  docUploadService: DocUploadService;
  titleService: TitleService;
  authFetch: AuthFetch;
  jwtStorage: JwtStorage;
  errorLogger: ErrorLogger;
  currentUserService: CurrentUserService;
  prmService: PrmService;
  navManager: NavManager;
  owningUnitService: OwningUnitService;
  subjectService: SubjectService;
  commonLoader: CommonDocLoader;
  jobService: JobService;

  private constructor(config: CommonConfig) {
    this.jwtStorage = new JwtStorage(config);
    this.authFetch = createAuthFetch(config.auth.tokenName, this.jwtStorage);
    this.errorLogger = new ErrorLogger(config.shortEnv, this.jwtStorage, this.authFetch);
    this.currentUserService = new CurrentUserService(config, this.authFetch, this.jwtStorage);
    this.prmService = new PrmService(config, this.authFetch);
    this.navManager = new NavManager(config.appName, config.shortEnv, this.currentUserService);

    this.docService = new DocService(this.authFetch, this.prmService, window.sessionStorage as any);
    this.docUploadService = new DocUploadService(this.prmService, this.docService);
    this.titleService = new TitleService(this.authFetch);
    this.owningUnitService = new OwningUnitService(this.authFetch, this.prmService);
    this.subjectService = new SubjectService(this.prmService, this.currentUserService);
    this.commonLoader = new CommonDocLoader(this.currentUserService, this.prmService, this.subjectService);
    this.jobService = new JobService(this.authFetch);
  }

  // Pass dependencies in here, configs etc.
  static create(config: CommonConfig): ServiceRegistry {
    return new ServiceRegistry(config);
  }
}



// WEBPACK FOOTER //
// ./src/services/ServiceRegistry.ts